<script setup lang="ts">
import { computed } from "vue";
import ProjectNavigation from "./ProjectNavigation.vue";

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    isVisible: boolean;
    ariaLabel?: string;
  }>(),
  {
    ariaLabel: "Project navigation",
  }
);

const emit = defineEmits<{
  "update:modelValue": [expanded: boolean];
}>();

const isExpanded = computed(() => props.modelValue);
const toggle = () => emit("update:modelValue", !isExpanded.value);

const navRegionId = "project-sub-sidebar-nav";
</script>

<template>
  <aside
    :aria-label="ariaLabel"
    :aria-hidden="!isVisible"
    :inert="!isVisible"
    class="flex h-full flex-col overflow-hidden bg-slate-50 shadow-[inset_-1px_0_0_0_var(--color-slate-200)] will-change-[width] contain-[layout_style]">
    <nav
      :id="navRegionId"
      class="flex-1 overflow-x-hidden overflow-y-auto">
      <!-- v-if, not just inert: while hidden the navigation would still be mounted and fetching
           (e.g. the mapping-status summary) for whatever id it can see — including none. -->
      <ProjectNavigation
        v-if="isVisible"
        :is-expanded="isExpanded"
        @toggle="toggle" />
    </nav>
  </aside>
</template>
